import { useLocation, useNavigate } from 'react-router-dom'

import { IncomeSource } from '@documents/types'
import { DirectTask, TrueworkJsStrategy } from '@frame/lib/api/tasks/types'
import { useStore } from '@frame/lib/stores/useStore'
import { routes } from '@frame/routes'

import { useRootContext } from '../context'

export function useVerifyViaDocuments(): (task?: DirectTask) => Promise<void> {
  const navigate = useNavigate()
  const location = useLocation()
  const { actions } = useRootContext()
  const { docsForMortgageEnabled } = useStore(({ session }) => ({
    docsForMortgageEnabled: session?.configuration.docs_for_mortgage_enabled ?? false,
  }))

  const params = new URLSearchParams(location.search)

  async function verify(selectDirectTask?: DirectTask) {
    let directTask = selectDirectTask
    if (!selectDirectTask) {
      if (docsForMortgageEnabled) {
        directTask = await actions.createDirectTask({
          strategy: TrueworkJsStrategy.DOCUMENTS,
          income_source: IncomeSource.GENERIC_INCOME,
        })
      } else {
        directTask = await actions.createDirectTask({
          strategy: TrueworkJsStrategy.DOCUMENTS,
          income_source: IncomeSource.OTHER_INCOME,
        })
      }

      if (!directTask) {
        throw new Error('Failed to create task')
      }

      navigate(`${location.pathname}/${directTask?.id}?${params.toString()}`, { replace: true, state: location.state })
    } else {
      directTask = await actions.addStrategyToDirectTask({
        directTaskId: selectDirectTask?.id,
        strategy: TrueworkJsStrategy.DOCUMENTS,
      })
    }

    navigate(`${routes.documents}/${directTask?.id}?${params.toString()}`, {
      state: { task: directTask },
    })
  }

  return verify
}
